<template>
    <div>
        <b-form-group
            description="Add number that can be picked"
            label="Number"
            :label-cols="3"
            :horizontal="false"
        >
            <b-form-input
                :plain="false"
                v-model.number="number"
                type="number"
                >
            </b-form-input>
            <b-form-select
                :plain="false"
                :options="constraints.selectables.items"
                :value="selected"
                >
            </b-form-select>
            <div class="form-actions" style="margin: 10px">
                <b-button variant="success" @click="add">Add</b-button>
            </div>
        </b-form-group>
        <b-form-group
            description="Possible number to pick in this range"
            label="Range"
            :label-cols="3"
            :horizontal="false"
        >
            <b-form-input
                :plain="false"
                v-model.number="constraints.selectables.range.from"
                type="number"
                placeholder="From"
                >
            </b-form-input>

            <b-form-input
                :plain="false"
                v-model.number="constraints.selectables.range.to"
                type="number"
                placeholder="To"
                >
            </b-form-input>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'

export default {
    components: {
        cSwitch
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            number: null,
            selected: null
        }
    },
    computed: {
        constraints() {
            let constr = this.value

            return constr
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        add() {
            this.constraints.selectables.items.push(this.number);
            this.selected = this.number
            this.number = null
        }
    }
    
}
</script>